import { Component, Input, OnInit } from '@angular/core';
import { NavParams, ToastController, ModalController, Platform } from '@ionic/angular';
import { LocaldataService } from '../../../service/localdata/localdata.service';
import { DatePipe } from '@angular/common';
import { FormattingService } from '../../../service/formatting/formatting.service';

import { Chart, ChartConfiguration, Color } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

//import { AnalyticsResponse } from './chart-data.interface';

import { BaseChartDirective } from 'ng2-charts';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../service/config/config.service';
import { AuthService } from '../../../service/auth/auth.service';
//import { callback } from 'chart.js/dist/helpers/helpers.core';

@Component({
  selector: 'app-weighindetails',
  templateUrl: './weighindetails.page.html',
  styleUrls: ['./weighindetails.page.scss'],
})
export class WeighindetailsPage implements OnInit {


  public selectedIssueType: string = '';
  public changeDescription: string = '';

  public jsonObj: any;

  public chartLabels = ['Stivelse', 'Smuds', 'Sten'];
  public chartColours = ['#009ABD', '#00e676', '#ff5722'];
  public borderWidth = 0.5;
  public borderColor = '#ddd';
  public chartXAxis = ['Dit kampagne gennemsnit', "AKD's kampagne gennemsnit"];

  public chartDetails: any;
  private chartDetailsInstance;

  public formSubmitting: boolean = false;
  public textarea: string;


  @Input() modalCtrl: ModalController;
  closeModal() {
    return this.modalCtrl.dismiss();
  }

  public AddLegendPadding = {
    id: '1',
    beforeInit(chart) {
      const originalFit = chart.legend.fit;
      chart.legend.fit = function fit() {
        originalFit.bind(chart.legend)();
        this.height += 10;
      };
    }
  };

  public barChartLegendDetails = true;
  public barChartPluginsDetails = [ChartDataLabels, this.AddLegendPadding];
  /*public barChartDataDetails: ChartConfiguration<'bar'>['data'] = {
    labels: this.chartLabels,
    datasets: []
  };*/
  public barChartOptionsDetails: ChartConfiguration<'doughnut'>['options'] = {
    responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      text: 'Det aktuelle læs',
      display: true
    },
    datalabels: {
      color: '#000000',
      textAlign: 'center',
      font: {
        lineHeight: 1.6
      },
      display: true,
      formatter: (value, ctx) => {
        const label = ctx.chart.data.labels[ctx.dataIndex];
        return `${label} \n ${Math.round(value * 10) / 10}%`;
      }
    },
    tooltip: {
      enabled: false
    },
    legend: {
      position: 'bottom'
    }
  }

  };

  public barChartDataDetails: ChartConfiguration<'doughnut'>['data'] = {
    labels: this.chartLabels,
    datasets: []
  };



  constructor(private navParams: NavParams, private localData: LocaldataService, private datePipe: DatePipe, private formattingService: FormattingService, private toastController: ToastController, private config: ConfigService, private http: HttpClient, private auth: AuthService) {
    this.jsonObj = this.navParams.get('weighin');

    const detailsConfig = {
      chartLabels: this.chartLabels,
      chartColours: this.chartColours,
      borderWidth: this.borderWidth,
      borderColor: this.borderColor
    };

    this.createChartDetailsDetails(this.jsonObj, detailsConfig);
  }

  ngOnInit() {
  }

  createChartDetailsDetails(data: any, config: any){

    let ChartData = data;
    const { chartLabels, chartColours, borderWidth, borderColor } = config;
  
    let compositionDataStarch = ChartData.starch;
    let compositionDataDirt = ChartData.dirt;
    let compositionDataStone = ChartData.stone;
  
      this.barChartLegendDetails = true;
      this.barChartPluginsDetails = [];
      this.barChartDataDetails = {
        labels: config.chartLabels,
        datasets: [
          {
            data: [compositionDataStarch, compositionDataDirt, compositionDataStone],
            backgroundColor: chartColours
          }
        ]
      }
      console.log('barChartDataDetails',this.barChartDataDetails);
      this.barChartPluginsDetails = [ChartDataLabels];
    
      this.barChartOptionsDetails = {
        responsive: false,
        maintainAspectRatio: true,
        
        plugins: {
          title: {
            text: 'Det aktuelle læs',
            display: true
          },
          datalabels: {
            color: '#000000',
            textAlign: 'center',
            font: {
              lineHeight: 1.6
            },
            display: true,
            formatter: (value, ctx) => {
              const label = ctx.chart.data.labels[ctx.dataIndex];
              return `${label} \n ${Math.round(value * 10) / 10}%`;;
            }
          },
          tooltip: {
            enabled: false
          },
        },
        scales: {
          x: {
              stacked: true,
              display: false,   
            },
            y: {
              stacked: true,
              display: false,          
            }
        },
        
      };
    }




    onIssueTypeChange() {
      if (!this.selectedIssueType) {
        this.changeDescription = '';
      }
    }
  
    isFormValid(): boolean {
      return true;//this.selectedIssueType.length>0;
    }


    async submitChanges(){
      this.formSubmitting = true;
  
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');
  
      const options = {
        headers: headers
      };
  
      var submitformdata = {
        changes: this.changeDescription.split("\n").join("<br/>"),
        serialnumber: this.jsonObj?.serialnumber,
        senderdisplayname: this.auth.userProfile.displayname,
        replyto: this.auth.userProfile.email,
        farmerdisplayname: this.jsonObj?.farmer?.displayname,
        farmernumberakd: this.jsonObj?.farmer?.farmernumberakd
      }
  
      console.log('submitformdata', submitformdata);
  
      return this.http.post(this.config.basePath + '/api/driveradmins/suggestchanges', submitformdata, options )
      .subscribe(
        (val) => {
          this.formSubmitting = false;
         
                // Show success message
      this.presentSuccessToast();
      this.closeModal();
      
      // Reset form
      this.selectedIssueType = '';
      this.changeDescription = '';
          //return this.modalCtrl.dismiss();
          
        },
        response => {
          this.formSubmitting = false;
         
          //this.openAlert();

                // Show success message
      this.presentSuccessToast();
      this.closeModal();
      
      // Reset form
      this.selectedIssueType = '';
      this.changeDescription = '';
          return this.modalCtrl.dismiss();
        }
      );
    }
  
  
    async presentSuccessToast() {
      const toast = await this.toastController.create({
        message: 'Ændringsanmodning er sendt',
        duration: 2000,
        position: 'bottom',
        color: 'success'
      });
      toast.present();
    }
}
